<script setup>
import PageTitle from "../template/PageTitle.vue"
import TabStructure from './tabs/Structure.vue'

</script>
<template>
    <section>
        <PageTitle :main="$t('editIndicators')" sub="" imagem="editInd.png" />
        <TabStructure :isCreating="false"></TabStructure>
    </section>
</template>
<script>
export default {
    name: 'EditIndicators',
    components: {TabStructure},
    data(){
        return {
        }
    },
    mounted(){
        
    }
}
</script>
<style></style>